<template>
	<div>
		<AppDialog @onCancel="cancel">
			<div class="merge-column-dialog-content-container text-align-center pa-6">
				<div class="dialog-title">Merge</div>
				<div class="dialog-description">Drag to reorder</div>
				<div class="dialog-body">
					<Container @drop="onDrop">
						<Draggable v-for="opt in optionsLocal" :key="opt.id">
							<div class="merge-option flex-centerize mt-1">
								<SIcon class="mr-4" name="drag-sign" />
								<div class="text-field-style flex-1">{{ opt.text }}</div>
							</div>
						</Draggable>
					</Container>
					<PreviewBox title="Merge preview" class="merge-preview mt-2">
						<div>
							<div v-for="(row, index) in columnsToPreview" :key="index" class="mx-1 my-2">{{ row || ' ' }}</div>
						</div>
					</PreviewBox>
				</div>

				<div class="dialog-bottom text-align-center mt-4">
					<PrimaryButton @click="merge()">Merge</PrimaryButton>
				</div>
			</div>
		</AppDialog>
	</div>
</template>

<script>
import { Draggable, Container } from 'vue-smooth-dnd';

import PreviewBox from '@/components/common/PreviewBox';

import AppDialog from '../AppDialog/AppDialog';

import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';

export default {
	name: 'MergeColumnDialog',
	components: {
		AppDialog,
		Container,
		Draggable,
		PreviewBox,
	},
	props: {
		columnToMerge: { type: Object },
		columnToMergeTo: { type: Object },
		dialogPromiseHandlers: { type: Object },
		columnsSample: { type: Array },
	},
	computed: {
		columnsToPreview() {
			const [first, last] = this.optionsLocal;
			return this.columnsSample.map((row) => `${row[first.origin]} ${row[last.origin]}`).slice(0, 5);
		},
	},
	methods: {
		onDrop(dropResult) {
			const { removedIndex, addedIndex } = dropResult;
			const removedItem = this.optionsLocal.slice(removedIndex, removedIndex + 1);
			const addedItem = this.optionsLocal.slice(addedIndex, addedIndex + 1);
			this.optionsLocal.splice(removedIndex, removedIndex + 1, ...addedItem);
			this.optionsLocal.splice(addedIndex, addedIndex + 1, ...removedItem);
		},
		cancel() {
			this.dialogPromiseHandlers.reject();
		},
		merge() {
			const payload = {
				[this.columnToMergeTo.header]: this.optionsLocal.map((item) => item.text),
			};
			this.dialogPromiseHandlers.resolve({ status: 'success', payload });
			AppDialogManagerService.closeCurrentDialog(this.optionsLocal);
		},
	},
	data() {
		const getItem = (column) => ({ text: column.header, origin: column.headerOrigin });

		const { columnToMerge, columnToMergeTo } = this;

		return {
			optionsLocal: [getItem(columnToMerge), getItem(columnToMergeTo)],
		};
	},
};
</script>

<style scoped lang="scss">
.merge-column-dialog-content-container {
	position: relative;
	text-align: left;

	.merge-option {
		&:hover {
			cursor: pointer;

			::v-deep svg {
				opacity: 0.3;
				transition: 0.2s;
			}
		}
		&:not(:hover) ::v-deep svg {
			opacity: 1;
			transition: 0.3s;
		}
	}
	::v-deep {
		.smooth-dnd-ghost {
			transform: none !important;
		}
	}

	.merge-preview {
		max-height: 100%;
	}
}
</style>
